import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Bar"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.9999 0.75H8.24993C7.83571 0.75 7.49993 1.08579 7.49993 1.5V7.0275C6.01376 7.89817 5.14377 9.53085 5.24993 11.25V21.75C5.24993 22.1642 5.58571 22.5 5.99993 22.5H9.74993V21H6.74993V11.25C6.74993 8.859 8.42318 8.235 8.48693 8.21175L8.99993 8.04V2.25H11.2499V6H12.7499V1.5C12.7499 1.08579 12.4141 0.75 11.9999 0.75ZM18.75 8.25H11.25C10.8358 8.25 10.5 8.58579 10.5 9V12C10.5038 14.1936 12.0874 16.0654 14.25 16.4325V21H12V22.5H18V21H15.75V16.4325C17.9126 16.0654 19.4962 14.1936 19.5 12V9C19.5 8.58579 19.1642 8.25 18.75 8.25ZM15 15C16.6569 15 18 13.6569 18 12V9.75H12V12C12 13.6569 13.3431 15 15 15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Bar.vue"]]);
